import { PLANS } from '../actionTypes';
import CONSTANTS from '../constants';

const initialState = {
  content: [],
  plansStatus: undefined,
  plansError: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PLANS.FETCH:
      return {
        ...state,
        plansStatus: CONSTANTS.API_STATUS.STARTED,
      };
    case PLANS.SUCCESS:
      return {
        ...state,
        ...action.payload,
        plansStatus: CONSTANTS.API_STATUS.SUCCEEDED,
      };
    case PLANS.FAILED:
      return {
        ...state,
        plansError: action.payload,
        plansStatus: CONSTANTS.API_STATUS.FAILED,
      };
    default:
      return state;
  }
};
